import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyedropper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEyedropper"><Path d="M11.5 8.5L5.5 14.5L4.5 17.5L4 18C3.44772 18.5523 3.44772 19.4477 4 20C4.55228 20.5523 5.44772 20.5523 6 20L6.5 19.5L9.5 18.5L15.5 12.5" stroke="currentColor"/><Path d="M16.5 13.5L10.5 7.5L12.5 5.5H14.5L15.5 4.5C16.6046 3.39543 18.3954 3.39543 19.5 4.5C20.6046 5.60457 20.6046 7.39543 19.5 8.5L18.5 9.5V11.5L16.5 13.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconEyedropper;
